import { render, staticRenderFns } from "./TagBirthday.vue?vue&type=template&id=d9a436ca&scoped=true&"
import script from "./TagBirthday.vue?vue&type=script&lang=ts&"
export * from "./TagBirthday.vue?vue&type=script&lang=ts&"
import style0 from "./TagBirthday.vue?vue&type=style&index=0&id=d9a436ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a436ca",
  null
  
)

export default component.exports